<template>
  <div :class="'checkBox ' + (value ? 'true' : '')" @click="click">
    <i class="el-icon-loading" v-if="loading"></i>
    <i class="fa fa-check-circle" v-if="value && !loading"></i>
    <i class="fa fa-ban" v-else-if="!value && !loading"></i>
    {{text ? text : value ? '是' : '否'}}
  </div>
</template>

<script>
  export default {
    name: 'checkBox',
    model: {
      prop: 'value',
      event: 'change'
    },
    props: {
      value: {
        type: Boolean,
        default: false,
      },
      text: {
        type: String,
        default: ''
      },
      asyncClick: {
        type: Function,
        default: null,
      }
    },
    data() {
      return {
        loading: false,
      }
    },
    methods: {
      async click() {
        this.$emit('change', !this.value)
        if (this.asyncClick) {
          const res = this.asyncClick()
          if (res instanceof Promise) {
            this.loading = true;
            try {
              await res;
            } finally {
              this.loading = false;
            }
          }
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
.checkBox {
  white-space: nowrap;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  i {
    font-size: 1.2vw;
  }
}
.true {
  color: #239efb;
}
</style>